import { Container, Row, Col } from 'react-bootstrap';
import StyledText from '../../../../app/components/styledComponents/StyledText';
import { Link } from 'react-router-dom';
import NotFoundImage from '../../assets/images/notFound.webp';
import { useEffect } from 'react';

const NotFound404 = () => {
  useEffect(() => {
    // This won't change the server response, but can be helpful for SEO and analytics
    document.title = '404 - Page Not Found';
    window.history.replaceState(null, '', '/404'); // Optional: Change the URL path to '/404' for clarity
  }, []);

  return (
    <main>
      <Container className="my-2 py-5">
        <Row>
          <Col
            xs={12}
            className="d-flex flex-column align-items-center justify-content-center h-100"
          >
            <img
              loading="lazy"
              src={NotFoundImage}
              alt=""
              className="hover-up"
            />

            <StyledText
              $fontSize="24px"
              $fontWeight="400"
              color="bodyMedium"
              className="text-center"
            >
              The link you clicked may be broken or the page may have been
              removed.
              <br />
              Visit the <Link to={'/home'}>Homepage</Link> or Contact us about
              the problem
            </StyledText>
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default NotFound404;
